import React, { useState, useEffect } from 'react';
import { ChevronUp } from 'lucide-react';

/**
 * ScrollToTopButton - A floating button that appears when the user scrolls down
 * and allows them to quickly scroll back to the top of the page.
 * 
 * @param {Object} props
 * @param {number} [props.showAfter=400] - Scroll distance in pixels before button appears
 * @param {string} [props.className] - Additional CSS classes
 */
const ScrollToTopButton = ({ showAfter = 400, className = '' }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > showAfter);
    };

    window.addEventListener('scroll', handleScroll);
    // Check initial scroll position
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, [showAfter]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!isVisible) return null;

  return (
    <button
      onClick={scrollToTop}
      className={`fixed bottom-6 right-6 p-3 bg-[#52A675] hover:bg-[#4A9168] text-white rounded-full shadow-lg transition-all z-30 ${className}`}
      aria-label="Back to top"
    >
      <ChevronUp size={24} />
    </button>
  );
};

export default ScrollToTopButton;
